import { ExternalLink } from "lucide-react";
import { useSelector } from "react-redux";
import CustomText from "components/Atoms/CustomText/CustomText";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";
import { ActionLink, Banner, Copy } from "./ExternalActionBannerStyled";

interface ExternalActionBannerProps {
  headingId: string;
  title: string;
  description: string;
  href: string;
  actionText: string;
  linkLabel: string;
}

const ExternalActionBanner = ({ headingId, title, description, href, actionText, linkLabel }: ExternalActionBannerProps) => {
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  return (
    <Banner aria-labelledby={headingId}>
      <Copy>
        <div id={headingId} role="heading" aria-level={2}>
          <CustomText text={title} type={TextType.H3} color={COLORS.Crimson} />
        </div>
        <CustomText text={description} type={TextType.P1} color={COLORS.Gunmetal} />
      </Copy>
      <ActionLink href={href} target="_blank" rel="noopener noreferrer"
        $biggerCursor={biggerCursor} aria-label={linkLabel}>
        {actionText}<ExternalLink size={16} aria-hidden="true" />
      </ActionLink>
    </Banner>
  );
};

export default ExternalActionBanner;
